import React, { useState } from 'react';
import Card from '@mui/material/Card';
import Switch from '@mui/material/Switch';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { GetNotificationsUserlist, ActiveorDeactivateUserNotification } from '../../Services/AdminApi'
import { useParams, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEffect } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';

export default function OutstandingReminderTemplate() {
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);

  const [assignrolesopen, setOpenRole] = useState(false);

  const [userList, setUserList] = useState([]);
  const { notificationid } = useParams();

  // Use useLocation to get the location object, which includes search parameters
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const notificationId = searchParams.get('notificationid');

  // Log the notificationId to check if it's correctly retrieved
  console.log('NotificationId:', notificationId || notificationid);

  //  useEffect(() => {
  //    // Fetch user data based on notificationId
  //    GetNotificationsUserlist(notificationId)
  //      .then((response) => setUserList(response))
  //      .catch((error) => console.error('Error fetching user list:', error));
  //  }, [notificationId]);


  useEffect(() => {
    GetNotificationsUserlist(notificationId || notificationid)
      .then((response) => setUserList(response))
      .catch((error) => console.error('Error fetching user list:', error));
  }, [notificationId, notificationid]);

  const handleSwitchChange = async (userId, currentStatus) => {
    console.log(userId, currentStatus);
    const newStatus = !currentStatus;

    try {
      // Update user status via API
      let response = await ActiveorDeactivateUserNotification(notificationId, userId, newStatus);
      if (response.status === 200) {
        toast.success(`User notification updated successfully!`);

        setUserList((prevUsers) =>
          prevUsers.map((user) =>
            user.userId === userId ? { ...user, isActive: newStatus } : user
          )
        );
      }
      else {
        toast.error("An error occurred while updating the user notification status.");
      }
    } catch (error) {
      console.error("Switch change error:", error);
      toast.error(`Error updating user status: ${error.message}`);
    }
  };

  const columnsdata = [
    { field: 'sno', headerName: 'Sr. No.', width: 50, },
    { field: 'userName', headerName: 'User Name', width: 200 },
    { field: 'email', headerName: 'Email', width: 250 },
    { field: 'mobileNo', headerName: 'Mobile No.', width: 150 },
    { field: 'role', headerName: 'Roles', width: 120 },
    {
      field: 'isActive',
      headerName: 'Active',
      sortable: false,
      renderCell: (params) => {
        return (
          <Switch
            defaultChecked={params.row.isActive}
            onChange={() => handleSwitchChange(params.row.userId, params.row.isActive)}
          />
        )
      },
    },
  ];
  const assignrolesClickOpen = () => {
    setOpenRole(true);
  };

  const assignrolesClose = () => {
    setOpenRole(false);
  };
  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="main-title">Outstanding Reminder</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <span>Home</span>
                </li>
                <li className="breadcrumb-item active">Outstanding Reminder</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* <section className="content">
        <div className="container-fluid">
          <Card className='custum-shadow py-3 px-3'>
            <CardContent>
              <div style={{ border: "1px solid #ddd", maxWidth: "600px", margin: "auto" }}>
                <table style={{ background: "#5d0000", width: "100%", maxWidth: "600px", margin: "auto" }}>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: "left", padding: "30px" }}>
                        <img src='https://i.ibb.co/TBpxXz2/logo-white.png' alt='Logo' width={80} /><br />
                        <img src='https://i.ibb.co/9gdq9CQ/double-check.png' alt='' width={40} style={{marginTop: "20px"}} />
                        <p style={{ fontSize: "20px", color: "#FFF", fontWeight: "500", margin: "20px 0 0" }}>Hi, Sonu Sharma</p>
                        <p style={{ fontSize: "28px", margin: "0", color: "#FFF" }}>Your Invoice #9865 is due!</p>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table style={{ background: "#FFF", width: "100%", maxWidth: "600px", margin: "auto" }}>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: "left", padding: "30px 30px 15px" }}>
                        <p style={{ fontSize: "14px", fontWeight: "500", margin: "0px 0 10px", color: "#000", lineHeight: "25px" }}>I hope you are doing well.</p>
                        <p style={{ fontSize: "14px", fontWeight: "500", margin: "0px 0 10px", color: "#000", lineHeight: "25px" }}>Our records show that we haven't yet received payment of <b>₹450.50</b> for Invoice <b>#9865</b>, which is overdue by 7 days. It would be appreciated if you look into this.</p>
                        <p style={{ fontSize: "14px", fontWeight: "500", margin: "0px 0 10px", color: "#000", lineHeight: "25px" }}>Again, please contact me in case of any queries regarding the payment. Else, please organize for settlement of this invoice immediately.</p>
                        <p style={{ fontSize: "14px", fontWeight: "500", margin: "0px", color: "#000", lineHeight: "25px" }}>In case the payment is already sent, please disregard this notice.</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "left", padding: "0px 30px 15px" }}>
                        <h4 style={{ margin: "10px 0 0", fontSize: "16px", fontWeight: "600", color: "#5d0000", padding: "5px 0 0px", }}>Invoice Details</h4>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: "0px 30px 30px" }}>
                        <table style={{ width: "100%" }}>
                          <tr>
                            <td style={{ textAlign: "left", color: "#000", fontWeight: "600", border: "1px solid #999", padding: "10px" }}>Invoice Id</td>
                            <td style={{ textAlign: "left", color: "#000", fontWeight: "600", border: "1px solid #999", padding: "10px" }}>#9868</td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left", color: "#000", fontWeight: "600", border: "1px solid #999", padding: "10px" }}>Invoice Date</td>
                            <td style={{ textAlign: "left", color: "#000", fontWeight: "600", border: "1px solid #999", padding: "10px" }}>Jan 04, 2023</td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left", color: "#000", fontWeight: "600", border: "1px solid #999", padding: "10px" }}>Amount</td>
                            <td style={{ textAlign: "left", color: "#000", fontWeight: "600", border: "1px solid #999", padding: "10px" }}>₹450.50</td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                  </tbody>
                </table>

                <table style={{ background: "#fbfbfb", width: "100%", maxWidth: "600px", margin: "auto", borderTop: "1px solid #ddd" }}>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: "left", padding: "15px 30px" }}>
                        <img src='https://mvload.in/images/logo-pdf.png' alt='' width={80} />
                        <p style={{ fontSize: "13px", color: "#000", fontWeight: "500", margin: "10px 0 0" }}>
                          Mvikas Super Logistic
                          <br />
                          11g, Big Jo's Tower Netaji Subhash Place, Rohini 110034</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CardContent>
          </Card>
        </div>
      </section> */}

      <section className="content mt-4">
        <div className="container-fluid">
        <Card className='custum-shadow mt-3'>
            <DataGrid sx={{ p: "1rem" }} className='table-ui'
              rows={userList}
              columns={columnsdata}
              components={{}}
              autoHeight={true}
              pagination
              getRowId={(user) => user.userId}
              pageSize={rowsPerPage}
              rowsPerPageOptions={rowsPerPageOptions}
              onPageSizeChange={(newPageSize) => {
                setRowsPerPage(newPageSize);
              }}
            />
          </Card>
        </div>
      </section>

      {/*  */}
      <Dialog
        fullWidth={true}
        maxWidth="xs"
        open={assignrolesopen}
        onClose={assignrolesClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <div className='delete-alert'>
            <HelpOutlineRoundedIcon />
            <p>Are you sure you want to inactive this user?</p>
            <Button onClick={assignrolesClose} variant="contained">Yes</Button>
            <Button onClick={assignrolesClose} autoFocus variant="outlined" className='ml-2'>
              No
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}